/* Theme 主题 */

const width = "220px";

const menuWidth = "200px";

const collapseWidth = "60px";

const height = "60px";

const commonBgColor = "#191a23";

const commonActiveColor = "#1890ff";

// const commonBgColor = "#c9121e";

// const commonActiveColor = "#F56C6C";

export default {
  namespaced: true,

  state: {
    themeInfo: {
      logo: {
        show: true,
        //
        width,
        //
        collapseWidth,
        // 高度
        height,

        menuWidth,
      },

      aside: {
        show: true,
        //
        width,
        //
        collapseWidth,

        menuWidth,
        //
        background: commonBgColor,
        // 是否开启路由
        isRouter: true,
        //
        inactiveColor: "white",
        //
        activeColor: "white",
        //
        inactiveBackground: "",
        //
        activeBackground: commonActiveColor,
      },

      header: {
        //
        show: true,
        //
        height,
        //
        background: commonBgColor,

        color: "white",
      },

      tabs: {
        show: true,
        //
        height: "40px",
        //
        background: "#f0f2f5",

        inactiveColor: "black",

        activeColor: commonActiveColor,
      },

      main: {
        show: true,
        //
        background: "#f5f7f9",
      },

      footer: {
        show: false,
        //
        height,
        //
        background: "white",
      },
    },
  },

  mutations: {},
};
